import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SensorState } from './sensor-state';
export const SENSOR_FEATURE_KEY = 'sensorFeature';

export namespace SensorSelector {
  export const selectSensorFeatureState = createFeatureSelector<SensorState>(SENSOR_FEATURE_KEY);

  export const selectAllSensorTypes = createSelector(
    selectSensorFeatureState,
    (state: SensorState) => state.sensorTypes, // Type comes from SensorTypeState
  );
}
